import {computed, MaybeRefOrGetter, toValue} from "vue";
import useAgendaOperators from "@/agenda/composables/useAgendaOperators";
import useTeamSchedule from "@/team/composables/useTeamSchedule";
import {OperatorChoice, preferredOperator, rankOperators} from "@/agenda/lib/habilitation";

export type {OperatorChoice};

/**
 * The collaborators a picker offers for an act, in the team's order.
 *
 * Everybody, always: those habilitated for the type — and the laboratory,
 * when one is named — first and marked, then those with a planning, then the
 * rest. `preferred` says who the picker lands on.
 */
const useOperatorChoices = (
    request: MaybeRefOrGetter<{appointmentTypeId: number | null; laboratoryId?: number | null}>
) => {
    const {operators} = useAgendaOperators();
    const {schedulesByAccessId} = useTeamSchedule();

    const choices = computed(() => {
        const {appointmentTypeId, laboratoryId} = toValue(request);

        return rankOperators(operators.value, schedulesByAccessId.value, appointmentTypeId, laboratoryId ?? null);
    });

    const preferred = (sessionAccessId: number | null) => preferredOperator(choices.value, sessionAccessId);

    return {choices, preferred};
};

export default useOperatorChoices;
